import "./Notifications.scss";

import React, { useState } from "react";
import { compose } from "redux";

import { UrlProvider } from "../../../../../../../api/UrlProvider";
import withAnalysisCategories from "../../../../../../../hocs/withAnalysisCategories";
import withManualStrategies from "../../../../../../../hocs/withManualStrategies";
import withTranslations from "../../../../../../../hocs/withTranslations";
import CheckDouble from "../../../Homepage/assets/icons/check-double.svg";
import Filter from "../../../Homepage/assets/icons/filter.svg";
import Settings from "../../../Homepage/assets/icons/settings.svg";
import LandingTypography from "../../../Homepage/components/LandingTypography";
import { SimpleButton } from "../buttons/simpleButton";
import NotificationsTabs from "../NotificationsTabs";
import withNewNotifications from "../../../../../../../hocs/withNewNotifications";
import FiltersDesktop from "../filters/FiltersDesktop";
import getNotificationTypesFromSelectedTab from "../../../../../../../lib/notifications/getNotificationTypesFromSelectedTab";
import { hasActiveNotificationFilters } from "../../../../../../../lib/notifications/hasActiveNotificationFilters";
import Loader from "../../../../../common/Loader";

const Notifications = ({
  markAsReadAction,
  resetFilters,
  onToggle,
  translate,
  locale,
  filters,
  selectedNotificationsTab: notificationTab,
  setSelectedNotificationsTab,
  globalLoading
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const filtersActive = hasActiveNotificationFilters(filters);

  const onSelectedTabChange = tab => {
    setSelectedNotificationsTab(tab?.name);
  };

  return (
    <LandingTypography className={"plans"}>
      <aside className="lp_notifications rounded-lg relative">
        <header className={"flex justify-between align-center"}>
          <h1
            className={"pl-4 pt-4 mb-3 text-xl.1 font-semibold font-semibold"}
          >
            {translate("Notifications")}
          </h1>
          <div className={"flex gap-6 pr-3"}>
            <SimpleButton
              icon={Settings}
              text={translate("Settings")}
              to={UrlProvider.getUrl("fe.settingsPageCategory", {
                settingsCategory: "notifications",
                locale
              })}
              onClick={onToggle}
            />
            {filtersActive ? (
              <SimpleButton
                text={translate("clear_notification_filters")}
                onClick={resetFilters}
              />
            ) : (
              <SimpleButton
                icon={CheckDouble}
                text={translate("mark_category_as_read", {
                  category: translate(notificationTab?.name)
                })}
                onClick={() => {
                  const notificationTypes =
                    getNotificationTypesFromSelectedTab(notificationTab);
                  markAsReadAction(
                    notificationTypes.length > 0 ? { notificationTypes } : {}
                  );
                }}
              />
            )}
            <SimpleButton
              icon={Filter}
              highlighted={filtersActive}
              text={translate("Filter")}
              showBackground
              onClick={() => {
                setShowFilters(prev => !prev);
              }}
            />
          </div>
        </header>
        <NotificationsTabs
          onToggle={onToggle}
          selectedTab={notificationTab}
          onSelectedTabChange={onSelectedTabChange}
        />
        {showFilters ? (
          <FiltersDesktop onClose={() => setShowFilters(false)} />
        ) : null}
        {globalLoading ? (
          <div className={"absolute top-0 left-0 w-full h-full z-10 flex align-center justify-center"}>
            <div className={"absolute top-0 left-0 w-full h-full bg-white opacity-60"} />
            <div className={"relative z-10"}>
              <Loader small />
            </div>
          </div>
        ) : null}
      </aside>
    </LandingTypography>
  );
};

export default compose(
  withTranslations,
  withManualStrategies,
  withAnalysisCategories,
  withNewNotifications
)(Notifications);
